'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 0;\n  height: 0;\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0,0,0,0.5);\n  background: linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0,0,0,0.75));\n  opacity: 0;\n  transition: opacity 1s;\n  &.active {\n    z-index: 100;\n    width: 100vw;\n    height: 100vh;\n    opacity: 1;\n    transition: opacity 1s;\n  }\n'], ['\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 0;\n  height: 0;\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0,0,0,0.5);\n  background: linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0,0,0,0.75));\n  opacity: 0;\n  transition: opacity 1s;\n  &.active {\n    z-index: 100;\n    width: 100vw;\n    height: 100vh;\n    opacity: 1;\n    transition: opacity 1s;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

exports.default = _styledComponents2.default.div(_templateObject);


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/auth/modal/wrapper.js
// module id = 899
// module chunks = 0